import React, { useEffect, useState } from 'react'
import {
  Box, Grid, Typography, RadioGroup,
  FormControl, Alert, AlertTitle,
  Collapse
} from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { b2cSignupSlice } from '../../../../reducers'
import { CREATE_ACCOUNT_STEP, REVIEW_AND_PAYMENT_STEP } from '../progress-bar'
import { Paypal } from './paypal'
import { CreditCard } from './credit-card'
import { ApplePay } from './applePay'
import makeStyles from '@mui/styles/makeStyles'
import { useFormFactor } from '../../../../hooks'
import { PaymentHeading } from './heading'

export const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  root: {
    gridArea: 'paymentInfo',
    background: '#F8F9FD',
    maxWidth: '580px',
    padding: `${spacing(1)} ${spacing(3)} ${spacing(3)} ${spacing(4)}`,
    borderRadius: '10px',
    marginTop: spacing(2),
    [breakpoints.down('md')]: {
      marginRight: 0,
      marginBottom: 0,
      maxWidth: '100%',
      marginTop: 0
    }
  },
  alert: {
    margin: spacing(2, 0),
    padding: spacing(2.5),
    maxWidth: '100%'
  },
  title: {
    color: '#000000'
  },
  titleDisabled: {
    color: '#707070'
  }
}))

const PaymentInfoForm = (props) => {
  const classes = useStyles()
  const paymentInfoSubmitted = useSelector(b2cSignupSlice.selectors.selectPaymentInfoSubmitted)
  const currentStep = useSelector(b2cSignupSlice.selectors.selectCurrentStep)
  const account = useSelector(b2cSignupSlice.selectors.selectAccount)
  const [selectedValue, setSelectedValue] = useState('')
  const { firstName, lastName } = useSelector(b2cSignupSlice.selectors.selectAccount)
  const disabled = useSelector(b2cSignupSlice.selectors.selectDisabled)
  const dispatch = useDispatch()
  const paymentError = useSelector(
    b2cSignupSlice.selectors.selectPaymentError
  )

  const { isSmallTablet, isMobile } = useFormFactor()

  const handleChange = (event) => {
    setSelectedValue(event.target.value)
    dispatch(b2cSignupSlice.actions.clearPaymentError())
  }

  useEffect(() => {
    if (firstName && lastName) {
      // set hidden fields for Recurly
      document.getElementById('first_name').value = firstName
      document.getElementById('last_name').value = lastName
    }
  }, [firstName, lastName])

  const formRef = React.useRef()

  const hideMobile = () => ((isSmallTablet || isMobile) && currentStep === CREATE_ACCOUNT_STEP)

  useEffect(() => {
    if (account?.paymentMethod?.object === 'credit_card') {
      setSelectedValue('creditCard')
      return
    }
    if (account?.paymentMethod?.object?.indexOf('paypal') > -1) {
      setSelectedValue('paypal')
    }
  }, [account])

  return (
    <>
      {!hideMobile() && (
        <Box className={classes.root}>

          <form id='payment' ref={formRef}>
            <Box sx={{ position: 'absolute', left: '-9999px' }}>
              <input type='text' data-recurly='first_name' id='first_name' />
              <input type='text' data-recurly='last_name' id='last_name' />
            </Box>
            <Grid container direction='column' spacing={1} sx={{ mt: 2 }}>
              <PaymentHeading hideMobile={false} />
              <Collapse in={currentStep === REVIEW_AND_PAYMENT_STEP} timeout={1000}>
                {paymentError && (
                  <Alert severity='error' className={classes.alert} onClose={() => dispatch(b2cSignupSlice.actions.clearPaymentError())}>
                    <AlertTitle sx={{ fontWeight: 'bold' }}>{paymentError.title}</AlertTitle>
                    {paymentError.message}
                  </Alert>
                )}

                <Box my={1}>
                  <Typography sx={{ fontWeight: 'bold', mb: 1, mt: 2 }} variant='caption'>Select a payment method</Typography>
                </Box>
                <FormControl component='fieldset'>
                  <RadioGroup value={selectedValue} disabled={paymentInfoSubmitted || disabled} onChange={handleChange}>
                    {window.ApplePaySession &&
                      <ApplePay selectedValue={selectedValue} formRef={formRef} />}
                    <Paypal selectedValue={selectedValue} />
                    <CreditCard selectedValue={selectedValue} formRef={formRef} />
                  </RadioGroup>
                </FormControl>

              </Collapse>
              {/* )} */}
              <Grid item xs={12}>
                <input name='recurly-token' type='hidden' data-recurly='token' />
              </Grid>
            </Grid>
          </form>

        </Box>)}
    </>
  )
}
export default PaymentInfoForm
